import AdvancedController from "./advanced-controller"
import gsap from 'gsap'
import throttle from 'just-throttle';
export default class HeaderController extends AdvancedController {

    static values = {
        isNavToggled: Boolean,
        isSearchToggled: Boolean,
    }

    static targets = [
        "navToggle",
        "searchForm",
        "searchField",
        "searchToggleButton",
        "progress"
    ]

    connect() {
        super.connect();
        this.navMainTarget = document.getElementById('nav-main')

        // outside click close
        window.addEventListener('click', (e) => {
            if (this.isSearchToggledValue && !this.searchFormTarget.contains(e.target) && !this.searchToggleButtonTarget.contains(e.target)) {
                this.isSearchToggledValue = false
                this._handleState();
            }
        })

        window.addEventListener('scroll', throttle(this.updateProgress.bind(this), 40, { leading: true, trailing: true }));
        setInterval(this.updateProgress.bind(this), 400)
        this.updateProgress();
    }

    onToggleClick(e) {
        e.preventDefault();
        this.isNavToggledValue = !this.isNavToggledValue;
        if (this.isNavToggledValue) this.isSearchToggledValue = false
        this._handleState();
    }

    onSearchToggle(e) {
        e.preventDefault();
        this.isSearchToggledValue = !this.isSearchToggledValue;
        if (this.isSearchToggledValue) this.isNavToggledValue = false
        this._handleState();
    }

    updateProgress() {
        const docHeight = document.documentElement.scrollHeight
        const innerHeight = window.innerHeight
        let progressValue = (window.pageYOffset / (docHeight - innerHeight) * 100).toFixed(2)

        progressValue = progressValue > 99 ? 100 : progressValue
        progressValue = progressValue < 1 ? 0 : progressValue

        gsap.to(this.progressTarget, { width: `${progressValue}%` })
    }

    _handleClasses() {
        this.element.classList.toggle('-nav-toggled', this.isNavToggledValue)
        this.element.classList.toggle('-search-toggled', this.isSearchToggledValue)
    }

    _handleState() {
        this._handleClasses();

        if (this.isNavToggledValue) {
            this.navMainTarget.style.display = "flex"
        } else {
            this.navMainTarget.style.display = "none"
        }
    }

    messageCloseNav() {
        for (const controller of this.getAllControllers("nav-main-sub-menu")) {
            controller.messageClose();
        }
        this.isNavToggledValue = false
        this._handleState();
    }

}